import { createSelector } from '@reduxjs/toolkit';

import configSelector from './config';

const bookingEnableSelector = createSelector(
  configSelector,
  config => config.booking?.enable || false,
);

export default bookingEnableSelector;
